var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "input input--select",
      class: { "input--secondary": _vm.secondary }
    },
    [
      _vm.label
        ? _c(
            "label",
            { class: _vm.labelClass, attrs: { for: "select" + _vm._uid } },
            [_vm._v(_vm._s(_vm.label))]
          )
        : _vm._e(),
      !_vm.showNativeSelect
        ? _c("v-select", {
            attrs: {
              options: _vm.optionSet,
              disabled: _vm.$attrs.disabled,
              clearable: false,
              value: _vm.selectedValue,
              placeholder: this.disableDefault ? undefined : _vm.defaultOption,
              searchable: false,
              "select-on-tab": true
            },
            on: { input: _vm.update }
          })
        : _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.currentValue,
                  expression: "currentValue"
                }
              ],
              attrs: { disabled: _vm.$attrs.disabled, id: "select" + _vm._uid },
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.currentValue = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                }
              }
            },
            _vm._l(_vm.options, function(option) {
              return _c(
                "option",
                { key: option.value, domProps: { value: option.value } },
                [_vm._v(_vm._s(option.label))]
              )
            }),
            0
          ),
      _c("icon", {
        staticClass: "select-input-icon",
        attrs: { name: _vm.iconName, size: _vm.iconSize }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }